import { BrxLink } from '@mediashop/app/bloomreach/types';
import { LinkOpenInTab } from '@mediashop/base/pattern/atom/LinkOpenInTab';
import { CSSProperties, useRef } from 'react';
import { SpecialButtonProps } from './index';

const componentName = 'special-button';

const SpecialButton = ({
    backgroundColorHex,
    fontColorHex,
    borderColorHex,
    tab,
    link: linkProp,
}: SpecialButtonProps) => {
    const ref = useRef<HTMLDivElement | null>(null);
    const link = linkProp as BrxLink;

    const styles = {
        [`--${componentName}-border-color`]: backgroundColorHex,
        [`--${componentName}-border-color-hover`]: borderColorHex,
    } as CSSProperties;

    return (
        <div ref={ref} className={componentName} style={styles}>
            <LinkOpenInTab tab={tab} link={link} backgroundColorHex={backgroundColorHex} fontColorHex={fontColorHex}>
                {link.text}
            </LinkOpenInTab>
        </div>
    );
};

export default SpecialButton;
